module.exports = "label {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.panel-heading {\n  background-color: lightgray; }\n\n.panel-heading.error-heading {\n  background-color: red; }\n\n.panel-heading.multiple-segments {\n  background-color: orange; }\n\n.panel-heading.manual-header {\n  background-color: #ffee00; }\n\n.group-btn {\n  font-size: 10px; }\n\n.group-btn button {\n  height: 15px;\n  padding-top: 0px;\n  text-align: center;\n  font-size: 10px; }\n\n.error {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/fcd/fcd.component.scss
// module id = ./src/app/shared/fcd/fcd.component.scss
// module chunks = main